import { JSONSchema7, JSONSchema7Type } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';
import { SelectOption } from '../types';

export default (currVer: JSONSchema7): JSONSchema7 => {
  const properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 4;

  properties['utilizeHiddenComponents'] = {
    $id: `${currVer.$id}/utilizeHiddenComponents`,
    default: false,
    type: 'boolean'
  };

  properties['options'].default = (
    properties['options'].default as unknown as SelectOption[]
  ).map((option) => {
    option.utilize = '';
    return option;
  }) as unknown as JSONSchema7Type;

  return {
    ...currVer,
    properties
  };
};
